import React from 'react'
import CopyrightFooter from './copyright_footer'

interface LayoutProps {
  children: React.ReactNode
}

const AuthLayout: React.FC<LayoutProps> = (props) => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* <header className="bg-white py-2 flex justify-center items-center absolute top-0 w-full">
        <Link to="/">
          <img src={Logo} alt="SDGs Lodge Logo" width={80} height={20} />
        </Link>
      </header> */}
      <div>{props.children}</div>
      <CopyrightFooter />
    </div>
  )
}

export default AuthLayout
